export const magentoWebsiteIdSleep = 4
export const magentoStoreIdSleep = 13